import { axios, API } from './config';

export const clientPortalAPI = {
  generateAccess: async (data) => {
    const response = await axios.post(`${API}/client-portal/generate-access`, data);
    return response.data;
  },
  
  login: async (email, accessCode) => {
    const response = await axios.post(`${API}/client-portal/login`, {
      email,
      access_code: accessCode
    });
    return response.data;
  },
  
  getContract: async (contractId, token) => {
    const response = await axios.get(`${API}/client-portal/contract/${contractId}?token=${token}`);
    return response.data;
  },
  
  signContract: async (data, token) => {
    const response = await axios.post(`${API}/client-portal/sign?token=${token}`, data);
    return response.data;
  },
  
  getInvoices: async (contractId, token) => {
    const response = await axios.get(`${API}/client-portal/invoices/${contractId}?token=${token}`);
    return response.data;
  }
};
